import { emailSection, phoneSection, pISection,
    passwordSection, termsAndConditions ,baseErrorSectionMsg } from '../constants/Validations'

const BuildDynamicMsg = ( validEmail, validPI, validPhoneNumber,  validPassword, acceptTermsAndConditions ) => {
    let dynamicMsg = baseErrorSectionMsg
    if( !validEmail )
        dynamicMsg += emailSection
    if( !validPI )
        dynamicMsg += pISection
    if( !validPhoneNumber )
        dynamicMsg += phoneSection
    if( !validPassword )
        dynamicMsg += passwordSection
    if( !acceptTermsAndConditions )
        dynamicMsg += termsAndConditions

    if( dynamicMsg === baseErrorSectionMsg )
        return ''
    return dynamicMsg
}

export default BuildDynamicMsg